import React from "react";


export function Header() {

    let host = "https://" + process.env.REACT_APP_HTTP_SERVER
    let login = host + "/xpay_index.html#/main/login"
    let register = host + "/xpay_index.html#/main/register"
    return <header id="header1">

        <div id="topHeader">

            <div className="wrapper">

                <div className="top_nav">
                    <div className="container">

                        <div className="left">

                            <ul>
                                <li><a href="mailto:podrska@sistemx.ba"><i className="fa fa-envelope"></i>
                                    podrska@sistemx.ba</a></li>

                            </ul>

                        </div>


                        <div className="right">

                            <ul>
                                <li className="link"><a
                                    href={login}>Prijava</a></li>
                                <li className=" link"><a
                                    href={register}>Registracija</a>
                                </li>
                                <li className="link"><a
                                    href="https://sistemx.ba/korisnicko-uputstvo-kviklik/"
                                    target="new">Pomoć</a>
                                </li>
                                <li><a href="https://www.facebook.com/theSistemX?fref=ts" target="new"><i
                                    className="fa fa-facebook"></i></a></li>
                                <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                            </ul>

                        </div>


                    </div>
                </div>

            </div>

        </div>
    </header>
}